import { Component, HostListener } from '@angular/core';

import { Platform, MenuController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { Logger, ThemeService } from 'ngx-elvis-ds';
import { ConfigService } from './config.service';
import { GUIService } from './gui/gui.service';
import { VERSION } from './version';
import { DeviceType } from './base/device-type.enum';
import { SoundService } from './services/sound.service';
import { ActivatedRoute } from '@angular/router';
import { I18NService } from './services/i18n.service';
import { GUIHelperService } from './gui-helper.service';
import { FileLogger } from './utils/file-logger';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent {

  version: any = VERSION;

  get isFullScreen() {
    return 1 >= window.screen.availHeight - window.outerHeight;
  }

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private guiSvc: GUIService,
    private soundSvc: SoundService,
    public configSvc: ConfigService,
    public themeSvc: ThemeService,
    public menuCtrl: MenuController,
    public i18nSvc: I18NService,
    private guiHelperSvc: GUIHelperService
  ) {
    this.initializeApp();
  }

  @HostListener('window:resize', ['$event'])
  onSetGuiScale = this.guiSvc.onSetGuiScale;

  @HostListener('click', ['$event'])
  async onClick(e) {
    if (window.innerWidth > 720) {
      this.soundSvc.play('click');
    }
    if (window.innerWidth < 720 && !this.isFullScreen) {
      await document.body.requestFullscreen();
    }
  }

  // override right click & touch end, replace with normal click
  @HostListener('contextmenu', ['$event'])
  onContextMenu(e) {
    if (
      this.configSvc.deviceType === DeviceType.SCO ||
      this.configSvc.deviceType === DeviceType.BAR ||
      this.configSvc.deviceType === DeviceType.BAR_SELF
    ) {
      e.preventDefault();
      const clickEvt = new MouseEvent('click', { bubbles: true });
      e.target.dispatchEvent(clickEvt);
      e.stopPropagation();
    }
  }

  @HostListener('touchend', ['$event'])
  onToucheEnd(e) {
    if ( this.configSvc.deviceType === DeviceType.SCO ) {
      // override 2 fingers click
      if (e.touches.length === 1) {
        e.preventDefault();
        const clickEvt = new MouseEvent('click', { bubbles: true });
        e.target.dispatchEvent(clickEvt);
        e.stopPropagation();
      }
    }
  }

  async initializeApp() {

    await FileLogger.init();
    await this.guiHelperSvc.init();

    this.platform.ready().then(async () => {
      // init plugins
      this.statusBar.styleDefault();
      this.splashScreen.hide();

      // init menuCtrl by disabling menus until
      this.guiSvc.enableSideMenus(false);

      // load configSvc
      await this.guiSvc.forceScreenOrientation();
      await this.configSvc.load();
      await this.themeSvc.load();

      // apply theme
      // if (this.configSvc.guiSettings.themeColors) {
      //   const themes = (this.themeSvc as any).themes;
      //   themes['app_config_theme'] = {
      //     name: 'app_config_theme',
      //     // brandLogo: 'assets/logos/tigros.png',
      //     colors: this.configSvc.guiSettings.themeColors
      //   };
      //   this.configSvc.theme = 'app_config_theme';
      // }
      this.themeSvc.apply(this.configSvc.theme);
      this.guiSvc.onSetGuiScale({ target: window });
    });
  }
}
